<template>

	<section v-if="detailsModal">

		<div class="back_lay" @click="closeModal"></div>

		<!-- Modal -->
		<div class="modal modal_shadow">

			<div @click="showCard(client._id)" class="modal__header clear_fix">
				<user-avatar :data="client" :set-class="'modal__avatar'"></user-avatar>
				<div class="modal__title">
					{{client.last_name}} {{client.first_name | one}}{{client.middle_name | one}}
				</div>
			</div>

			<!-- Outer -->
			<div class="modal__outer" v-show="!isCancel">

				<div class="modal__inner">
					<ul class="modal__list">
						<li class="modal__list-item">
							<span class="span-text t-right">Телефон:</span><span class="span-text t-left">+{{client.phone}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Дата/Время:</span><span
							class="span-text t-left">{{[visit.begin, 'X'] | moment('DD.MM.YY/HH:mm')}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Статус:</span><span
							class="span-text t-left">{{visit.status | status}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Стоимость визита:</span><span
							class="span-text t-left">{{visit.price}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Внесено:</span><span
							class="span-text t-left">{{visit.deposit}}</span>
						</li>
						<li class="modal__list-item">
							<span class="span-text t-right">Баланс клиента:</span><span
							class="span-text t-left">{{balance}}</span>
						</li>
						<li class="modal__list-item" v-show="visit.description">
							<span class="span-text t-right">Комментарий:</span>
						</li>
					</ul>

					<p class="modal__basic-text modal__basic-text_comment">
						{{visit.description}}
					</p>

				</div>
				<div class="modal__inner  modal__inner_mb">
					<div class="modal__btn-wrap">
						<button class="modal__btn modal__btn_orange modal__btn_mr"
										@click="startVisit" v-if="whenState(visit.status, ['came'])">
							Продолжить
						</button>
						<button class="modal__btn modal__btn_orange modal__btn_mr"
										@click="startVisit" v-if="whenState(visit.status, ['not_confirmed', 'confirmed'])">
							Начать прием
						</button>
						<button class="modal__btn modal__btn_decor"
										@click="editVisit" v-if="whenState(visit.status, ['not_confirmed', 'confirmed', 'came', 'completed'])">
							Редактировать
						</button>
					</div>
				</div>
				<div class="modal__inner">
					<div class="modal__btn-wrap">
						<button class="modal__btn modal__btn_blue_light modal__btn_mr"
										@click="changeTime" v-if="whenState(visit.status, ['not_confirmed', 'confirmed'])">
							Перенести
						</button>
						<button class="modal__btn modal__btn_decor modal__btn_gray"
										@click="cancel" v-if="whenState(visit.status, ['not_confirmed', 'confirmed'])">
							Отменить
						</button>
					</div>
				</div>
			</div>
			<!-- Outer End -->

			<!-- Outer -->
			<div class="modal__outer" v-show="isCancel">

				<div class="modal__inner">
					<form class="modal__form">
						<label class="modal__label bold">Укажите причину отмены:</label>

						<textarea class="modal__text-area" placeholder="Введите текст" v-model="reason"></textarea>

						<div class="modal__btn-wrap">
							<input type="button" class="modal__btn modal__btn_gray modal__btn_mr" value="Отменить"
										 @click="sendCancel(visit)">
							<button type="button" class="modal__btn modal__btn_decor" @click="cancelCancel">Назад</button>
						</div>

					</form>
				</div>
			</div>
			<!-- Outer End -->

			<i class="modal__icon_close icon ion-close trans" @click="closeModal"></i>
		</div>
		<!-- Modal End -->
	</section>

</template>

<script>
	export default {
		name: 'DetailsModal',
		computed: {
			isRegistry() {
				if (this.$route.path === '/registry')
					return true
			},
			doctorId() {
				if (this.$route.query.doctor)
					return this.$route.query.doctor
			},
			workerId() {
				return this.$store.state.auth.worker._id
			},
			doctorRoles() {
				return this.$store.state.auth.worker.role
			},
			client() {
				return this.visit.users[0]
			},
			isMyVisit() {
				return this.visit.workers[0]._id === this.workerId
			}
		},
		mounted() {
            console.log('test');
			this.$event.connect('openDetailsModal', (visit, forCancel) => {
				this.visit = visit
				this.detailsModal = true
				this.isCancel = forCancel || false
                this.balance = 0
                this.getBalance(visit)
			})

			this.$event.connect('closeDetailsModal', () => {
				this.closeModal()
			})
		},
		beforeDestroy() {
			this.$event.disconnect(['openDetailsModal', 'closeDetailsModal'])
		},
		data() {
			return {
				detailsModal: false,
				isCancel: false,
				visit: {},
				reason: '',
                balance: 0,
                
                
			}
		},
		methods: {
			showCard(id) {
				this.$router.push({
					name: 'Card',
					query: {
						patient: id,
						doctor: this.visit.workers[0]._id,
						visit: this.visit._id
					}
				})
				this.closeModal()
			},
			showClinic(id) {
				this.closeModal()

				this.$router.push({
					path: 'Clinic',
					query: {
						clinic: id
					}
				})
			},
			startVisit() {
				this.$store.dispatch('agenda/update', {
					id: this.visit._id,
					status: "came"
				}).then(() => {
					this.$router.push({
						name: 'Card',
						query: {
							patient: this.visit.users[0]._id,
							doctor: this.visit.workers[0]._id,
							visit: this.visit._id
						}
					})
					this.closeModal()
				})
			},
			editVisit() {
				this.$event.send('openEditModal', this.visit, this.visit.workers[0])
				this.closeModal()
			},
			changeTime() {
				this.$event.toast('i', "Выберите новое время для визита на календаре")
				this.$event.send('moveEvent', this.visit)
				this.closeModal()
			},
			cancel() {
				this.isCancel = true
			},
			sendCancel(visit) {
				if (!this.reason) {
					this.$event.toast('i', 'Укажите причину, пожалуйста')
					return false
				}

				this.$store.dispatch('agenda/update', {
					id: visit._id,
					reason_for_removal: this.reason,
					status: "canceled"
				}).then(response => {
					this.$event.send('updateEvents', response.worker_ids[0])
					this.closeModal()
				})
			},
			cancelCancel(){
				this.reason = ''
				this.isCancel = false
			},
			closeModal() {
				this.visit = {}
				this.detailsModal = false
				this.isCancel = false
				this.reason = ''
			},
			whenState(status, arr) {
				return arr.indexOf(status) !== -1
			},
            getBalance(visit) {
                this.$store.dispatch('agenda/list', {
                    user_ids: visit.user_ids,
                    clinic_id: visit.clinic_id,
                    status: 'completed'
                }).then((res) => {
                    res.data.forEach(({ deposit = 0, price = 0 }) => {
                       this.balance += (deposit - price); 
                    });
                });
            }
		}
	}
</script>

<style scoped>

	.modal {
		z-index: 510;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: white;
	}

</style>



// WEBPACK FOOTER //
// DetailsModal.vue?0e813e8f